import { Button, Col, Divider, Rate, Row, Typography } from "antd";
import styled, { keyframes } from "styled-components";

const { Title, Text } = Typography;

const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(16px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

/**
 * Kašnjenje je ograničeno: sa punim `index * 0.08s` je 20. kartica čekala
 * 1.6s pre nego što se uopšte pojavi, pa je "Učitaj još" delovalo kao da
 * ne radi. Plafon ujedno drži broj generisanih klasa na 8 umesto po jedne
 * za svaku karticu u listi.
 */
export const TenantCol = styled(Col)<{ $index?: number }>`
  display: flex;
  opacity: 0;
  animation: ${fadeInUp} 0.35s ease-out forwards;
  animation-delay: ${(p) => Math.min(p.$index ?? 0, 7) * 0.05}s;
`;

export const TenantCard = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: #fff;
  border-radius: 20px;
  padding: 20px;
  text-align: left;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
  box-shadow: 0 2px 12px rgba(216, 27, 96, 0.08);
  border: 1.5px solid #FDF0F4;
  height: 100%;
  width: 100%;
  cursor: pointer;
  will-change: transform;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(216, 27, 96, 0.15);
  }
`;

export const CardHeaderRow = styled(Row)`
  flex-wrap: nowrap;
  margin-bottom: 4px;
`;

export const TenantName = styled(Title)`
  &.ant-typography {
    margin: 0;
    color: #1e293b;
    font-size: 1em;

    a {
      color: inherit;
      text-decoration: none;
    }

    a:hover {
      color: var(--color-primary);
    }
  }
`;

export const LocationText = styled(Text)`
  &.ant-typography {
    color: #94a3b8;
    font-size: 13px;
  }
`;

export const PhoneLink = styled.a`
  color: #D81B60;
  font-size: 13px;
`;

export const CardDivider = styled(Divider)`
  &.ant-divider {
    margin: 14px 0;
    border-color: #FDF0F4;
  }
`;

export const InfoCol = styled(Col)`
  display: flex;
  flex-direction: column;
`;

export const PinIcon = styled.span`
  color: #D81B60;
`;

export const SocialLink = styled.a`
  color: #D81B60;
  font-size: 22px;
`;

export const TenantRate = styled(Rate)`
  &.ant-rate {
    font-size: 13px;
  }
`;

export const ReviewsLink = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: #D81B60;
  font-size: 12px;
  font-weight: 500;
  transition: color 0.2s ease;

  &:hover {
    color: #B0124A;
    text-decoration: underline;
  }
`;

export const FavoriteButton = styled.button<{ $active?: boolean }>`
  position: absolute;
  top: 12px;
  right: 12px;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: none;
  background: ${(p) => (p.$active ? "#fef2f2" : "#f1f5f9")};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  z-index: 1;

  &:hover {
    transform: scale(1.15);
    background: ${(p) => (p.$active ? "#fee2e2" : "#e2e8f0")};
  }

  &:active {
    transform: scale(0.95);
  }

  .anticon {
    font-size: 16px;
    color: ${(p) => (p.$active ? "#ef4444" : "#94a3b8")};
  }
`;

export const BookButton = styled(Button)`
  &.ant-btn {
    margin-top: 14px;
    border-radius: 14px;
    height: 42px;
    font-weight: 600;
    background: linear-gradient(135deg, #D81B60 0%, #FF7F6B 100%);
    border: none;
    box-shadow: 0 4px 12px rgba(216, 27, 96, 0.3);

    &:hover,
    &:focus {
      background: linear-gradient(135deg, #B0124A 0%, #E64A5E 100%) !important;
      border: none !important;
      box-shadow: 0 4px 16px rgba(216, 27, 96, 0.4);
    }

    &:active {
      background: linear-gradient(135deg, #8A0E3A 0%, #C21E56 100%) !important;
      border: none !important;
    }

    > .ant-wave {
      display: none;
    }
  }
`;

export const ResumeLink = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: #D81B60;
  font-size: 12px;
  font-weight: 500;

  &:hover {
    text-decoration: underline;
  }
`;

export default {
  TenantCol,
  TenantCard,
  CardHeaderRow,
  TenantName,
  LocationText,
  PhoneLink,
  InfoCol,
  PinIcon,
  CardDivider,
  SocialLink,
  TenantRate,
  BookButton,
  FavoriteButton,
  ReviewsLink,
  ResumeLink,
};
